import { useMemo } from 'react'
import { BaseProvider } from '@ethersproject/providers'
import { Contract, ContractInterface, ethers } from 'ethers'
import { JsonFragment } from '@ethersproject/abi'

function createContractInstance(
  provider: BaseProvider,
  address: string,
  abi: ethers.ContractInterface
): Contract | null {
  try {
    return new ethers.Contract(address, abi, provider)
  } catch (e) {
    console.error(e)
    return null
  }
}

export default function useContract(
  provider: BaseProvider,
  address: string,
  abi: JsonFragment[]
) {
  return useMemo<Contract | null>(
    () =>
      createContractInstance(
        provider,
        address,
        abi as unknown as ContractInterface
      ),
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [provider, address]
  )
}
